module.exports = __webpack_public_path__ + "static/media/19.ae73af6d.jpg";